export enum SubscriptionType {
  PAYPAL_BILLING_AGREEMENT = 'PAYPAL_BILLING_AGREEMENT',
  PAYPAL_SUBSCRIPTION = 'PAYPAL_SUBSCRIPTION',
}
